<template>
    <div class="mairesse-page">
        <content-details
            :title="item.title"
            :offset-size="0"
            :type-tags="item.typeTags"
            :infos="item.infos"
            size="front_large_21_9"
            :header-img="{
                src: item.image ? item.image.uri.url : null,
                alt: item.image ? item.image.meta.alt : null,
            }"
            :media-image="item.media_image ? item.media_image : null"
        >
            <template class="mairesse">
                <Row class="mairesse__top_content">
                    <el-col ref="sideMenu" class="mairesse__menu" :span="24">
                        <div class="mairesse__menu-top">
                            <h2
                                class="mairesse__menu-title"
                                @click="isMobileSize ? (sideMenuOpen = !sideMenuOpen) : false"
                            >
                                {{ $t('services.inThisSection') }}
                            </h2>
                            <div v-if="!isMobileSize || sideMenuOpen" class="mairesse__menu-container">
                                <div
                                    v-for="menuItem in item.related_content"
                                    :key="menuItem.meta.arity"
                                    class="mairesse__menu-link-container"
                                >
                                    <custom-link
                                        class="mairesse__menu-link"
                                        :to="menuItem.path.alias"
                                        name="fade"
                                        primary
                                        >{{ menuItem.title | decodehtml }}</custom-link
                                    >
                                </div>
                            </div>
                        </div>

                        <div class="mairesse__menu-under">
                            <img
                                class="mairesse__mayor-picture"
                                :src="item.media_image_1.meta.links.front_large_21_9"
                                :alt="item.media_image_1.meta.alt"
                            />

                            <div class="mairesse__menu-under-links">
                                <custom-link
                                    class="mairesse__menu-under-link"
                                    :to="`mailto:${item.mail}`"
                                    name="fade"
                                    primary
                                    hide-external
                                >
                                    <img
                                        class="socialNetwork__ico"
                                        src="/img/social-network/email-dark.svg"
                                        alt="Email"
                                    />
                                    {{ item.mail | decodehtml }}
                                </custom-link>

                                <custom-link
                                    class="mairesse__menu-under-link"
                                    :to="item.location_link.uri"
                                    name="fade"
                                    primary
                                    hide-external
                                >
                                    <img
                                        class="socialNetwork__ico socialNetwork__ico--map"
                                        src="~assets/img/map-marker-primary.svg"
                                        alt="Location"
                                    />
                                    {{ item.location_link.title | decodehtml }}
                                </custom-link>

                                <custom-link
                                    v-if="item.social_networks.facebook.uri"
                                    class="mairesse__menu-under-link"
                                    :to="item.social_networks.facebook.uri"
                                    name="fade"
                                    primary
                                    hide-external
                                >
                                    <img
                                        class="socialNetwork__ico"
                                        src="/img/social-network/facebook-dark.svg"
                                        alt="Facebook"
                                    />
                                    Facebook
                                </custom-link>
                                <custom-link
                                    v-if="item.social_networks.instagram.uri"
                                    class="mairesse__menu-under-link"
                                    :to="item.social_networks.instagram.uri"
                                    name="fade"
                                    primary
                                    hide-external
                                >
                                    <img
                                        class="socialNetwork__ico"
                                        src="/img/social-network/instagram-dark.svg"
                                        alt="Instagram"
                                    />
                                    Instagram
                                </custom-link>
                                <custom-link
                                    v-if="item.social_networks.twitter.uri"
                                    class="mairesse__menu-under-link"
                                    :to="item.social_networks.twitter.uri"
                                    name="fade"
                                    primary
                                    hide-external
                                >
                                    <img
                                        class="socialNetwork__ico"
                                        src="/img/social-network/twitter-dark.svg"
                                        alt="Twitter"
                                    />
                                    Twitter
                                </custom-link>
                            </div>
                        </div>
                    </el-col>

                    <!-- WYSIWYG (Contenu) -->
                    <el-col :span="24" class="mairesse__content" :style="{ minHeight: contentMinHeight }">
                        <container
                            v-if="reminders && reminders[$i18n.locale] && reminders[$i18n.locale].data.length > 0"
                            class="mairesse__reminders"
                            max-width="700px"
                            :no-margin="true"
                            :padding="false"
                        >
                            <reminder-block-list
                                :reminders="reminders"
                                :max-texte-length="60"
                                :section-title="$t('alerts.noticesAndReminders')"
                                :show-more-link="false"
                            />
                        </container>

                        <transition name="fade">
                            <Container v-if="item.body && item.body.processed" class="mairesse__wysiwyg-wrapper">
                                <Container max-width="700px" no-margin class="mairesse__wysiwyg">
                                    <wysiwyg :body="item.body.processed" />
                                </Container>
                            </Container>
                        </transition>

                        <!-- Paragraphs -->
                        <Container
                            v-if="item.customizable_content"
                            class="mairesse__custom_content"
                            max-width="700px"
                            no-margin
                        >
                            <paragraphs :item="item"></paragraphs>
                        </Container>

                        <!-- Box (actions et réglements) -->
                        <transition name="fade">
                            <Container
                                v-if="(actions && actions.length > 0) || (rules && rules.length > 0)"
                                class="mairesse__action-wrapper"
                            >
                                <Container max-width="700px" no-margin>
                                    <el-tabs v-model="activeActionTab">
                                        <el-tab-pane
                                            v-if="actions"
                                            :disabled="!actions || actions.length === 0"
                                            :label="$t('services.iWant')"
                                            lazy
                                            name="linkedActions"
                                            class="mairesse__actions-tab"
                                        >
                                            <Row
                                                v-for="action in actions"
                                                :key="action.id"
                                                class="mairesse__actions-row"
                                            >
                                                <el-col class="mairesse__actions-col" :span="24">
                                                    <custom-link
                                                        class="mairesse__actions-container-link"
                                                        :to="'/' + action.pathLangcode + action.pathAlias"
                                                        primary
                                                        bold
                                                    >
                                                        <uploaded-image
                                                            class="mairesse__actions-icon"
                                                            :path="checkActionMedia(action)"
                                                            alt
                                                        />

                                                        <span class="mairesse__actions-link">{{ action.title }}</span>
                                                        <i
                                                            class="mairesse__actions-arrow el-icon-arrow-right el-icon-right"
                                                        ></i>
                                                    </custom-link>
                                                </el-col>
                                            </Row>

                                            <Row class="mairesse__actions-more">
                                                <el-col :span="24">
                                                    <custom-link to="/allocutions-et-messages" primary underline bold>{{
                                                        this.$t('services.allActions')
                                                    }}</custom-link>
                                                </el-col>
                                            </Row>
                                        </el-tab-pane>

                                        <el-tab-pane
                                            v-if="rules"
                                            :disabled="!rules || rules.length === 0"
                                            :label="$t('services.associatedRules')"
                                            lazy
                                            name="associatedRules"
                                            class="mairesse__actions__tab"
                                        >
                                            <Row
                                                v-for="(rule, index) in rules"
                                                :key="index"
                                                class="mairesse__actions-row"
                                            >
                                                <el-col class="mairesse__actions-col" :span="24">
                                                    <custom-link
                                                        class="mairesse__actions-container-link"
                                                        :to="rule.uri"
                                                        primary
                                                        bold
                                                        hide-external
                                                    >
                                                        <span class="mairesse__actions-link mairesse__rules-link">{{
                                                            rule.title
                                                        }}</span>
                                                        <i
                                                            class="mairesse__actions-arrow el-icon-arrow-right el-icon-right"
                                                        ></i>
                                                    </custom-link>
                                                </el-col>
                                            </Row>
                                        </el-tab-pane>
                                    </el-tabs>
                                </Container>
                            </Container>
                        </transition>

                        <!-- Hub service - actualités vertical -->
                        <container v-if="newsList.length > 0" class="mairesse__news-list" max-width="700px" no-margin>
                            <h2 class="mairesse__section-title mairesse__section-title--news">
                                {{ this.$t('news.SpeechesMessages') }}
                            </h2>

                            <template v-if="item.description && item.description.value">
                                <div class="mairesse__news-description" v-html="item.description.value"></div>
                            </template>

                            <template v-for="n in newsList.slice(0, 3)">
                                <transition :key="n.id" name="fade">
                                    <Card
                                        type="news"
                                        v-bind="n"
                                        size="front_large_21_9"
                                        :media-image="n.mediaImage"
                                        :shadow="false"
                                        :url="`/${n.pathLangcode}${n.pathAlias}`"
                                    />
                                </transition>
                            </template>

                            <div class="link__section">
                                <span class="separator"></span>
                                <custom-link class="guide__link" :to="newsRoute" underline primary>
                                    {{ this.$t('news.seeAllMessages') }}
                                </custom-link>
                            </div>
                        </container>

                        <!-- Hub service - events vertical -->
                        <container v-if="events.length > 0" class="mairesse__events-list" max-width="700px" no-margin>
                            <h2 class="mairesse__section-title">
                                {{ this.$t('events.linkedEvents') }}
                            </h2>
                            <template v-for="event in events.slice(0, 2)">
                                <transition :key="event.id" name="fade">
                                    <Card
                                        type="event"
                                        v-bind="event"
                                        :media-image="event.mediaImage"
                                        size="front_large_21_9"
                                        :shadow="false"
                                        :url="`/${event.pathLangcode}${event.pathAlias}`"
                                    />
                                </transition>
                            </template>

                            <div class="link__section">
                                <span class="separator"></span>
                                <custom-link class="guide__link" :to="eventsRoute" underline primary>
                                    {{ this.$t('events.seeAllEvents') }}
                                </custom-link>
                            </div>
                        </container>
                    </el-col>
                </Row>
            </template>
        </content-details>
    </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import { mapState } from 'vuex';
// import moment from 'moment-timezone';

import ScrollMixin from '~/mixins/scroll-mixin.js';

import Card from '~/components/Card';
import Container from '~/components/Container';
import ContentDetails from '~/components/layout/ContentDetails';
import CustomLink from '~/components/CustomLink';
import Paragraphs from '~/components/Paragraphs';
import Row from '~/components/Row';
import UploadedImage from '~/components/UploadedImage';
import Wysiwyg from '~/components/Wysiwyg';

export default {
    head() {
        return this.$metaTags.head(this.metaTags);
    },
    components: {
        Card,
        UploadedImage,
        ContentDetails,
        CustomLink,
        Row,
        Container,
        Paragraphs,
        Wysiwyg,
    },

    mixins: [ScrollMixin],

    props: {
        metaTags: {
            default: null,
            type: Array,
        },
        initData: {
            default: null,
            type: Object,
        },
    },

    data() {
        const initData = cloneDeep(this.initData);
        return {
            item: initData.item,
            rules: initData.rules ?? [],
            actions: initData.actions,
            events: initData.events,
            newsList: initData.newsList,
            sideMenu: [],
            sideMenuOpen: false,
            activeActionTab: 'linkedActions',
            currentpath: null,
            isMobileSize: false,
            contentMinHeight: 'none',
        };
    },

    computed: {
        ...mapState({
            menu: state => state.menu.menu,
            reminders: state => state.reminders.reminders,
        }),
        newsRoute() {
            return '/' + this.$i18n.locale + '/' + this.$t('news.url');
        },
        eventsRoute() {
            return '/' + this.$i18n.locale + '/' + this.$t('events.url');
        },
    },

    asyncData({ app, query, store, params, error, env }, item) {
        return {
            item,
            actions: app.$drupalComponentsAdapter.normalizeItems(item.related_actions),
            events: app.$drupalComponentsAdapter.normalizeItems(item.related_events),
            newsList: app.$drupalComponentsAdapter.normalizeItems(item.related_speeches),
            rules: item.list_links,
        };
    },

    mounted() {
        this.getSectionMenu();
        this.getWindowSize();
        this.activeActionTab = this.actions.length === 0 && this.rules.length > 0 ? 'associatedRules' : 'linkedActions';
        window.addEventListener('resize', this.getWindowSize);
    },

    methods: {
        getWindowSize() {
            const windowWidth = window.innerWidth;
            this.isMobileSize = windowWidth <= 767;
            if (!this.isMobileSize && this.$refs.sideMenu && this.$refs.sideMenu.$el) {
                this.contentMinHeight = `${this.$refs.sideMenu.$el.clientHeight}px`;
            } else {
                this.contentMinHeight = 'auto';
            }
        },
        getSectionMenu() {
            // Example: /fr/services/bibliotheque
            const currentPath = window.location.pathname;
            this.currentpath = currentPath;

            // Set side bar menu
            this.menu.services[this.$i18n.locale].forEach(level1 =>
                level1.children.forEach(level2 =>
                    level2.children.forEach(level3 => {
                        if (level3.attributes.link.uri === currentPath && level3.children && level3.children.length) {
                            this.sideMenu = level3.children;
                        }
                    }),
                ),
            );
        },
        checkActionMedia(action) {
            try {
                return action.media_icon.meta.links.front_medium_16_9;
            } catch (e) {
                return null;
            }
        },
    },
};
</script>

<style lang="scss">
div.mairesse-page {
    @include media(xs) {
        margin-bottom: 60px;
    }

    @include media(lg) {
        transform: translateX(200px);
    }

    div.content-details .el-col.el-col-offset-5 {
        @include media(lg) {
            margin-left: 115px;
        }
    }

    .title__htag.title__htag--h1 {
        @include media(xs) {
            font-size: rem(25px);
        }
    }

    .media-pdf.container.padding {
        padding: 0;
    }

    .guide__link {
        font-size: rem(15px);
        font-weight: 700;
        text-decoration: underline;

        @include media(xs) {
            font-size: rem(13px);
        }
    }

    .separator {
        display: inline-block;
        height: 2px;
        width: 430px;
        background: lightgray;
        margin-right: 42px;
        transform: translateY(12px);

        @include media(xs) {
            transform: translateY(10px);
            margin-right: 20px;
        }
    }

    .link__section {
        display: flex;
        margin-bottom: 30px;
        margin-top: 34px;
        white-space: nowrap;

        .link__txt {
            font-weight: 400;
        }

        custom-link {
            display: inline-block;
            text-decoration: none;
        }
    }

    .card__image-container {
        @include media(sm) {
            max-width: 320px;
        }
    }

    div.content__header-img {
        @include media(lg) {
            transform: translateX(-200px);
            max-width: 1310px;
            height: 600px;
        }
    }

    .title__htag.title__htag--h1 {
        margin-top: 10px !important;
        margin-bottom: 15px;

        @include media(sm) {
            margin-bottom: 0;
        }
    }

    div.title {
        margin-left: auto;
        margin-right: auto;
        max-width: 700px;

        @include media(xs) {
            margin-right: -20px;
            padding-left: 0;
        }

        @include media(lg) {
            position: relative;
            top: -51px;
            width: 100%;
        }
    }
}

.mairesse {
    &__content,
    // &__custom_content,
    &__events {
        @include padding-content();
    }

    &__map-container {
        margin-top: 78px;
        margin-bottom: -4px;

        @include media(xs) {
            margin-bottom: -64px;
        }
    }

    &__section-title {
        font-size: rem(15px);
        letter-spacing: 0.6px;
        font-weight: 600;
        margin-bottom: 30px;
        text-transform: uppercase;

        &--news {
            margin-top: 50px;
            margin-bottom: 10px;

            @include media(sm) {
                margin-top: 80px;
            }
        }
    }

    &__menu-under-links {
        display: inline-flex;
        flex-flow: column;
    }

    &__menu-under-link {
        margin-bottom: 8px;

        .link__txt {
            display: flex;
            align-items: center;
        }

        .socialNetwork__ico {
            width: 27px;
            height: 27px;
            margin-right: 8px;

            &--map {
                margin-left: 0px;
            }
        }
    }

    // CARD STYLE
    &__news-list,
    &__events-list {
        .card:not(:last-of-type) {
            margin-bottom: 65px;
        }

        .el-card__body {
            padding: 0;
        }

        .card__content {
            display: flex;

            @include media(sm) {
                align-items: center;
                flex-flow: row !important;
            }
        }

        .media__image,
        .uploaded-image {
            min-height: 183px;
            height: 48vw;

            @include media(sm) {
                height: 183px;
            }
        }

        .card__image-container {
            @include media(sm) {
                margin-right: 50px;
            }
        }

        .card__title {
            font-size: 20px;
            font-weight: 700;

            @include media(xs) {
                font-size: 18px;
            }
        }

        .card__summary {
            font-size: rem(16px);
            font-weight: 400;
        }
    }
    // CARD STYLE END

    &__news-description {
        margin-bottom: 30px;
    }

    &__reminders {
        margin: 0;

        .reminders-block-list__header {
            margin-bottom: 5px;
        }

        .reminders-block-list {
            margin-top: -40px;
            margin-bottom: -8px;

            @include media(sm) {
                margin-top: -20px;
                margin-bottom: 45px;
            }
        }
    }

    &__top_content {
        margin-top: rem(40px);
        margin-bottom: 3rem;
    }

    &__bottom_content {
        margin-bottom: 3rem;
    }

    &__custom_content {
        margin-left: 0;

        @include media(xs) {
            margin-top: 40px;
            margin-bottom: 50px;
        }
    }

    &__wysiwyg {
        margin-bottom: 25px;
        font-size: rem(13px);

        @include media(sm) {
            margin-bottom: 50px;
            font-size: rem(18px);
        }
    }

    &__related-cards-item {
        margin-bottom: 25px;
    }

    &__menu {
        margin: auto;

        @include media(md) {
            max-width: 700px;
        }

        @include media(lg) {
            position: absolute;
            left: -320px;
            max-width: 320px;
        }
    }

    &__menu-top {
        border-radius: 4px;
        background-color: transparent;
        max-width: 630px;
        margin-left: auto;
        margin-right: auto;

        @include media(sm) {
            margin-bottom: 20px;
            padding: 45px;
            height: auto;
            box-shadow: 0 0 40px rgba(0, 0, 0, 0.08);
        }

        @include media(lg) {
            padding: 56px;
        }
    }

    &__menu-under {
        margin-bottom: 60px;
        margin-top: 40px;
        display: flex;
        flex-flow: column;

        @include media(sm) {
            flex-flow: row;
            max-width: 630px;
            margin-top: 45px;
            margin-left: auto;
            margin-right: auto;
        }

        @include media(lg) {
            margin-top: 0px;
            margin-bottom: 60px;
            flex-flow: column;
        }
    }

    &__mayor-picture {
        width: 100%;
        margin-bottom: 15px;
        margin-right: 0;

        @include media(sm) {
            max-width: 320px;
            margin-right: 20px;
            margin-bottom: 0px;
        }

        @include media(lg) {
            margin-right: 0;
            margin-bottom: 18px;
        }
    }

    &__menu-title {
        font-size: rem(13px);
        margin-top: 0;
        font-weight: 500;
        text-transform: uppercase;
        letter-spacing: 1.5px;
        margin-bottom: 26px;
        position: relative;
        cursor: pointer;
        box-shadow: 0 0 40px rgba(0, 0, 0, 0.08);
        padding: 15px 25px;
        border-radius: 4px;
        z-index: 2;
        background-color: white;

        @include media(sm) {
            background-color: transparent;
            padding: 0;
            font-size: rem(15px);
            cursor: initial;
            box-shadow: 0 0 40px rgba(0, 0, 0, 0);
        }

        &:after {
            content: '';
            background-image: url('~assets/img/gray-arrow.svg');
            display: block;
            position: absolute;
            right: 24px;
            top: 50%;
            transform: translateY(-50%);
            width: 9px;
            height: 6px;

            @include media(sm) {
                display: none;
            }
        }
    }

    &__menu-container {
        @include media(xs) {
            margin-top: -50px;
            box-shadow: 0 0 40px rgba(0, 0, 0, 0.2);
            border-radius: 4px;
            background-color: #fffefa;
            width: calc(100% + 20px);
            margin-left: -10px;
            margin-right: -10px;
            padding: 63px 35px;
            box-sizing: border-box;
            margin-bottom: 60px;
        }
    }

    &__menu-link-container {
        margin-bottom: 8px;

        &:not(:last-child) {
            &:after {
                content: '';
                display: block;
                height: 1px;
                width: 64px;
                background-color: $--color-gray;
                margin: 19px 0;
            }
        }
    }

    &__menu-link {
        font-size: rem(15px);
        color: $--color-primary;
        font-weight: 400;
    }

    &__rules-link {
        width: 100%;
    }

    &__actions-tab {
        text-align: center;

        @include media(xs) {
            padding-left: 10px;
            padding-right: 10px;
        }
    }

    &__action-wrapper {
        margin-top: 50px;
        margin-bottom: 5px;

        @include media(xs) {
            margin-top: -12px;
        }

        .el-tabs {
            &__nav {
                width: 100%;
            }

            &__item {
                width: 100%; // Change to 50% if you want add rules
                height: 92px;
                padding-top: 24px;
                padding-bottom: 24px;
                text-align: center;
                font-weight: 500;
                font-size: rem(14);
                text-transform: uppercase;
                transition: 0.5s all;
                letter-spacing: 0.56px;

                @include media(xs) {
                    white-space: initial;
                    line-height: 1.4;
                    padding-bottom: 18px;
                    min-height: 53px;
                    font-weight: 400;
                    height: auto;
                    padding-left: 0;
                    padding-right: 0;
                }

                &:hover {
                    color: $--color-green;
                }

                &.is-active {
                    color: $--color-green;
                    font-size: rem(16);
                    font-weight: 700;

                    @include media(xs) {
                        font-size: rem(14);
                    }
                }
            }

            &__nav-wrap {
                @include media(xs) {
                    //left: -10px;
                }

                &:after {
                    background-color: transparent;
                }
            }

            &__active-bar {
                height: 5px;
                background-color: $--color-green;
                width: 100% !important; // Change to 50% if you want add rules
            }

            &__header {
                margin-bottom: -5px;
            }

            &__content {
                padding: 38px 12px 44px;
                box-shadow: 0 0 64px rgba(0, 0, 0, 0.16);
                background-color: #f9f7f0;

                @include media(xs) {
                    padding-left: 0;
                    padding-right: 0;
                    width: 100%;
                    //margin-left: -10px;
                }

                @include media(sm) {
                    padding: 44px 47px 60px;
                }
            }
        }
    }

    &__actions-row {
        position: relative;
        min-height: 92px;
        margin: auto;
        max-width: 360px;
        padding-bottom: 35px;
        padding-top: 11px;
        box-shadow: 10 0 44px rgba(0, 0, 0, 0.16);

        @include media(xs) {
            min-height: 60px;
            padding-top: 0px;
            padding-bottom: 20px;
        }

        i {
            float: right;
        }
    }

    &__actions-col {
        display: flex;
        align-items: center;
        justify-content: space-between;

        &:after {
            content: '';
            display: block;
            position: absolute;
            bottom: -20px;
            height: 36px;
            width: 100%;
            background-size: 100% 80%;
            background: radial-gradient(ellipse at top, rgba(7, 38, 104, 0.5) 0%, rgba(255, 255, 255, 0) 40%) no-repeat;
            opacity: 0.15;

            @include media(xs) {
                opacity: 0.1;
                filter: blur(5px);
            }
        }
    }

    &__actions-container-link {
        display: flex;
        width: 100%;
        text-align: center;

        .link__txt {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;

            @include media(xs) {
                padding: 0px 0 10px;
            }
        }

        .link__internal-container {
            width: 100%;

            @include media(xs) {
                font-size: rem(13px);
                font-weight: 500;
            }
        }
    }

    &__actions-link {
        padding: 0 10px;
        color: $--color-green;

        @include media(xs) {
            padding: 0 18px;
            font-size: rem(13px);
            font-weight: 500;
        }
    }

    &__action-icon {
        max-width: 54px;

        @include media(xs) {
            max-width: 40px;
        }
    }

    &__actions-arrow {
        &::before {
            text-decoration: none !important;
            color: $--color-green;
            font-weight: bold;

            &:focus,
            &:hover {
                text-decoration: none !important;
            }
        }
    }

    &__actions-more {
        padding-top: 30px;

        @include media(xs) {
            padding-top: 0px;
        }

        .link__internal,
        .link__txt {
            font-weight: 500;
            color: $--color-info;

            @include media(xs) {
                color: $--color-primary;
                font-size: rem(13px);
            }
        }
    }

    &__actions {
        margin-bottom: 3rem;
        padding: 1rem;
    }

    .block {
        transform: translateY(1.5em);
    }

    &__map {
        @include media(lg) {
            transform: translateX(-200px);
        }
    }
}
</style>
